"use strict";

exports.__esModule = true;
var _HistoricalPartCountPopups = require("./HistoricalPartCountPopups");
Object.keys(_HistoricalPartCountPopups).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountPopups[key]) return;
  exports[key] = _HistoricalPartCountPopups[key];
});
var _HistoricalPartCountScreen = require("./HistoricalPartCountScreen");
Object.keys(_HistoricalPartCountScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountScreen[key]) return;
  exports[key] = _HistoricalPartCountScreen[key];
});